import { render, staticRenderFns } from "./LogoUploader.vue?vue&type=template&id=f38c863a&scoped=true"
import script from "./LogoUploader.vue?vue&type=script&lang=js"
export * from "./LogoUploader.vue?vue&type=script&lang=js"
import style0 from "./LogoUploader.vue?vue&type=style&index=0&id=f38c863a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f38c863a",
  null
  
)

export default component.exports